import { gql } from '@apollo/client';

const schema = {
  deliveryOrder: {
    name: 'deliveryOrder',
    serviceName: 'auth',
    query: gql`
      mutation deliveryOrder($order_id: String!, $shipping_code: String!, $sign_file: String) {
        deliveryOrder(order_id: $order_id, shipping_code: $shipping_code, sign_file: $sign_file) {
          model {
            id
          }
          messages
        }
      }
    `,
  },
};

export default schema;
